import styled, { css } from 'styled-components';
import CampaignLabel from './campaign-label';

export const Wrapper = styled.a<{ src: string; withoutLogo: boolean }>`
    visibility: visible;
    color: #898989;
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    transition: all 0.33s ease-in-out;
    background-image: url(${({ src }) => src});

    ${({ withoutLogo }) =>
        withoutLogo &&
        css`
            &::before {
                content: ' ';
                background: linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0.03) 31.74%,
                    rgba(0, 0, 0, 0.3) 90%
                );
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
            }
        `}

    .overlay {
        visibility: hidden;
        opacity: 0;
    }

    .delivery-label {
        visibility: visible;
        opacity: 1;
    }

    &:hover,
    &:focus-within {
        .overlay {
            visibility: visible;
            opacity: 1;
        }

        .delivery-label {
            visibility: hidden;
            opacity: 0;
        }
    }
`;

export const InnerWrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;

const includesDimensions = (dimension: string) => ['1x2', '2x2', '1x1', '2x1'].includes(dimension);

export const Title = styled.div<{ dimension: string; withDeliveryLabel: string }>`
    position: absolute;
    left: 0;
    width: 100%;
    text-align: center;
    color: ${({ theme }) => theme.functionColor.function0};
    font-weight: 700;
    z-index: 2;
    font-size: 20px;
    padding: 20px 8px 0;
    ${({ dimension, withDeliveryLabel }) =>
        includesDimensions(dimension)
            ? css`
                  padding-bottom: ${withDeliveryLabel ? 40 : 16}px;
                  bottom: 99px;
              `
            : css`
                  bottom: 80px;
              `};
`;
